import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bee73f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "DefaultLayout" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pre_trip_complete_day_modal = _resolveComponent("pre-trip-complete-day-modal")!
  const _component_sidebar = _resolveComponent("sidebar")!
  const _component_new_header = _resolveComponent("new-header")!
  const _component_impersonate_panel = _resolveComponent("impersonate-panel")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.complete_tms_day_state.is_opened)
      ? (_openBlock(), _createBlock(_component_pre_trip_complete_day_modal, {
          key: 0,
          "is-can-complete": _ctx.complete_tms_day_state.is_can_complete,
          onCancel: _ctx.onCompleteTmsDayCancel
        }, null, 8, ["is-can-complete", "onCancel"]))
      : _createCommentVNode("", true),
    _createVNode(_component_sidebar, {
      "is-opened": _ctx.store.is_sidebar_opened,
      onToggle: _ctx.store.toggleSidebar
    }, null, 8, ["is-opened", "onToggle"]),
    _createElementVNode("div", {
      class: _normalizeClass(['DefaultLayout__view', { wide: !_ctx.store.is_sidebar_opened }])
    }, [
      _createVNode(_component_new_header, {
        "without-sectors": _ctx.withoutSectors,
        onCompleteTmsDay: _ctx.onCompleteTmsDay
      }, null, 8, ["without-sectors", "onCompleteTmsDay"]),
      (_ctx.impersonate_state.is_active)
        ? (_openBlock(), _createBlock(_component_impersonate_panel, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view),
      _createVNode(_component_router_link, {
        to: "/navigation",
        class: "mobileButton"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_the_button, { class: "primary small" }, {
            default: _withCtx(() => [
              _createTextVNode(" Навигация ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 2)
  ]))
}